export var ERROR_CODES;
(function (ERROR_CODES) {
    // Connection-level errors
    ERROR_CODES[ERROR_CODES["BAD_REQUEST"] = 4000] = "BAD_REQUEST";
    ERROR_CODES[ERROR_CODES["UNAUTHORIZED"] = 4001] = "UNAUTHORIZED";
    ERROR_CODES[ERROR_CODES["NOT_FOUND"] = 4004] = "NOT_FOUND";
    // Application-level errors
    ERROR_CODES[ERROR_CODES["INVALID_REQUEST"] = -32600] = "INVALID_REQUEST";
    ERROR_CODES[ERROR_CODES["METHOD_NOT_FOUND"] = -32601] = "METHOD_NOT_FOUND";
    ERROR_CODES[ERROR_CODES["INVALID_PARAMS"] = -32602] = "INVALID_PARAMS";
    ERROR_CODES[ERROR_CODES["SUBSCRIPTION_NOT_FOUND"] = -32602] = "SUBSCRIPTION_NOT_FOUND";
    ERROR_CODES[ERROR_CODES["PARSE_ERROR"] = -32700] = "PARSE_ERROR";
})(ERROR_CODES || (ERROR_CODES = {}));
